import React, { useEffect } from "react";
import apiClientTimeseries from "../../../services/apiClientTimeseries";
import { getHeaders as getMetricHeaders } from "../../ApiHeaders/apiHeadersTimeseries";
import { datadogRum } from "@datadog/browser-rum";

interface MetricDropdownProps {
  onMetricsFetched: (metrics: any[]) => void;
}

const MetricDropdown: React.FC<MetricDropdownProps> = ({ onMetricsFetched }) => {
  useEffect(() => {
    const fetchMetrics = async () => {
      const startTime = performance.now();
      try {
        const headers = await getMetricHeaders();

        const response = await apiClientTimeseries.get(`/metric-config/`, {
          headers,
        });

        const metrics =
          response?.data?.response?.data?.map((metric: any) => ({
            metric_id: metric.metric_id,
            metric_name: metric.metric_name,
          })) || [];

        onMetricsFetched(metrics);

        datadogRum.addAction("Fetched Metrics Successfully", {
          count: metrics.length,
        });
      } catch (err) {
        console.error("Failed to fetch metrics", err);
        onMetricsFetched([]);

        datadogRum.addError("Failed to fetch metrics", { error: err });
      } finally {
        const duration = performance.now() - startTime;

        datadogRum.addAction("Metric API Response Time", { duration });
      }
    };

    fetchMetrics();
  }, []);

  return null;
};

export default MetricDropdown;
